import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';
import React from 'react';
import { CustomDomainModalUid } from '~/App/Modules/Settings/Domains/Components/LandingPage/LandingDomainAddOn';
import CustomDomainModal from '~/App/Modules/Settings/Domains/Modals/CustomDomainModal';
import { assetUrl } from '~/helpers';

export interface CustomDomainLearnMoreModalProps {
  title?: string;
  onCtaClick?: () => void;
  ctaVariant?: ButtonVariant;
  ctaText?: string;
}

export function CustomDomainLearnMoreModal({
  title = 'Custom domain add-on',
  onCtaClick,
  ctaVariant = ButtonVariant.Primary,
  ctaText = 'Get custom domain',
}: CustomDomainLearnMoreModalProps) {
  return (
    <CustomDomainModal uid={CustomDomainModalUid.LearnMore} showCloseButton>
      <div className='flex flex-col flex-1 gap-y-7 items-center'>
        <h4 className='text-xl v2-text-neutral-900 mx-auto mt-0 my-0 font-circular'>
          {title}
        </h4>
        <img
          className='max-w-full'
          src={assetUrl('assets/images/add-ons/custom-domain.png')}
        />
        <div>
          <p className='text-sm v2-text-neutral-500 text-center leading-5 mb-5'>
            Host your Bonjoro videos on a unique URL that matches your company
            domain:
          </p>
          <ul className='list-none pl-0 mb-0'>
            <li className='mb-3'>
              <FontAwesomeIcon
                className='mr-3 text-turquoise-700'
                icon={faCheck}
              />
              Add extra brand recognition to the videos you send with Bonjoro
            </li>
            <li className='mb-3'>
              <FontAwesomeIcon
                className='mr-3 text-turquoise-700'
                icon={faCheck}
              />
              Get more control of your email inboxing and improved
              deliverability
            </li>
            <li>
              <FontAwesomeIcon
                className='mr-3 text-turquoise-700'
                icon={faCheck}
              />
              Add a professional touch to your team&apos;s customer
              communications
            </li>
          </ul>
        </div>
        <Button
          className='w-full md:w-auto py-2'
          variant={ctaVariant}
          onClick={onCtaClick}
        >
          {ctaText}
        </Button>
      </div>
    </CustomDomainModal>
  );
}
